export default "__VITE_ASSET__BqEB7eEs__"